'use strict'

export let english={
  general: {
    add: "Add Risk",
    title: "Risk",
    probability: "Probability",
    impact: "Impact",
    approach: "Approach",
    riskStatement: "Risk Statement",
    status: "Status",
    statement: {
      if: "If",
      cause: "cause",
      thereIsA: "there is a",
      riskTypeOptions: {
        Threat: "threat",
        Opportunity: "opportunity"
      },
      that: "that",
      event: "event",
      whichWouldResultIn: "which would result in",
      effect: "effect"
    }
  },
  views: {
    identify: {
      title: "Identify view",
      columns: {
        id: "Id",
        title: "Title",
        category: "Category",
        cause: "Cause"
      }
    },
    followUp: {
      title: "Follow up view",
      columns: {
        id: "Id",
        title:"Title",
        solution: "Action",
        ownerAndActionee: "Owner / Actionee"
      }
    },
    present: {
      title: "Presentation view",
      menu: {
        title: "Risk options",
        backToRiskRegister: "Back to Risk Register",
        allRiskItems: "Show all risks",
        allOpenRiskItems: "Show all open risks",
        editRiskItem: "Edit this risk",
        selectRiskItem: "Select a risk to present",
        viewFullScreen: "View full screen",
        viewPDF: "View PDF",
      }
    }
  },
  identify: {
    title:"Identify",
    fields: {
      title: {
        title:"Title",
        description:"Descriptive risk title",
        help:"Short summary of the risk",
      },
      owner: {
        title:"Risk Owner",
        description:"The person who will manage the risk",
        help:"Who should make sure this risk is assessed, planned and action is implemented?",
      },
      type: {
        title:"Type",
        help:"Threat is used to describe an uncertain event that could have a negative impact - Opportunity an event that could have a favourable impact",
        options:{
          Threat:"Threat",
          Opportunity:"Opportunity"
        }
      },
      category: {
        title:"Category",
        help:"Which performance aspect is likely to have the most significant impact if the risk materializes?",
        options: {
          Time:"Time",
          Cost:"Cost",
          Scope:"Scope",
          Quality:"Quality",
          Benefit:"Benefit",
          Risk:"Risk"
        }
      },
      cause: {
        title:"Cause",
        description:"Describe the source of the risk. This part of the risk statement is: if <cause>",
        help:"What will cause the event to occur? What is the event or situation that gives rise to the risk. Example: technical requirement documentation is not complete",
      },
      event: {
        title:"Event",
        description:"Identify the area of uncertainty. This part of the risk statement is: there is a threat/an opportunity that <event>",
        help:"What is the area of uncertainty? Example: the technical design work cannot start",
      },
      effect: {
        title:"Effect",
        description:"Explain the impact(s) on the objectives. This part of the risk statement is: which would result in <effect>",
        help:"If this risk materializes, how will it impact the objectives?  Example: the project will be significantly delayed",
      }
    }
  },
  assess: {
    title:"Assess",
    fields: {
      assessment: {
        categories: {
          inherent: {
            title: "Inherent (original)"
          },
          residual: {
            title: "Residual (remaining)"
          }
        },
        fields: {
          impact: {
            title:"Impact",
            help:`What is the level of impact on objectives?

              Severe: Critical objective(s) will not be achieved
              Significant: Stated objective(s) will fall below acceptable level
              Moderate: Stated objective(s) will fall below goals but above minimum acceptable levels
              Minor: Stated objective(s) will fall below goals but well above minimum acceptable levels
              Negligible: No or little impact on achieving objectives`,
            options: {
              1: "Negligible",
              2: "Minor",
              3: "Moderate",
              4: "Significant",
              5: "Severe"
            }
          },
          probability: {
            title:"Probability",
            help:`What is the probability of this risk materializing?

              80-99% Very Likely
              60-79% Likely
              40-59% Possible
              20-39% Unlikely
              1-19% Very Unlikely`,
            options: {
              1: "Very Unlikely",
              2: "Unlikely",
              3: "Possible",
              4: "Likely",
              5: "Very Likely"
            }
          }
        }
      },
      impact: {
        title:"Impact",
        help:`What is the level of impact on objectives?

          Severe: Critical objective(s) will not be achieved
          Significant: Stated objective(s) will fall below acceptable level
          Moderate: Stated objective(s) will fall below goals but above minimum acceptable levels
          Minor: Stated objective(s) will fall below goals but well above minimum acceptable levels
          Negligible: No or little impact on achieving objectives`,
        options: {
          1: "Negligible",
          2: "Minor",
          3: "Moderate",
          4: "Significant",
          5: "Severe"
        }
      },
      probability: {
        title:"Probability",
        help:`What is the probability of this risk materializing?

          80-99% Very Likely
          60-79% Likely
          40-59% Possible
          20-39% Unlikely
          1-19% Very Unlikely`,
        options: {
          1: "Very Unlikely",
          2: "Unlikely",
          3: "Possible",
          4: "Likely",
          5: "Very Likely"
        }
      },
      proximity: {
        title:"Proximity",
        help:"How close in time is the event that would trigger the risk: Imminent, days, weeks, months or a specific date?"
      }
    }
  },
  plan: {
    title:"Plan",
    fields: {
      response: {
        title:"Response category",
        help:`Whish response is proportional to the risk and offers value for money?
          Avoid = make a change so that the threat can no longer happen or has no impact
          Reduce = reduce probability by some form of control and/or reduce impact should it occur
          Transfer = a third party taking responsibility for parts of the impact
          Accept = decision is taken to retain the risk
          Share = share gain or pain with partner
          Exploit = ensure that the opportunity will happen
          Enhance = enhance the probability of the event occurring, enhance the impact should it occur
          Contingent Plans = have fallback plans to deal with impact should the risk occur`,
        options:{
          Avoid:"Avoid (threat)",
          Reduce: "Reduce (threat)",
          Transfer: "Transfer (threat/opportunity)",
          Accept: "Accept (threat/opportunity)",
          Share: "Share (threath/opportunity)",
          Enhance: "Enhance (opportunity)",
          Exploit: "Exploit (opportunity)",
          ContingencyPlan: "Prepare contingent plans (threat/opportunity)"
        }
      },
      actionee: { title:"Risk actionee", help:"Who will implement the actions?"},
      action: { title:"Action", help:"What actions will be taken to resolve the risk?"}
    }
  },
  implement: {
    title:"Implement",
    fields: {
      status: {
        title:"Status",
        options:{
          Active: "Active",
          Closed: "Closed"
        }
      },
      comments: { title:"Comments", help:"Comments or current status"}
    }
  },
  riskRegister: {
    title: "Risk Register",
    description:"The risk register provides a record of identified risks, including their status and history. It is used to capture and maintain information on all the identified threaths and opportunities.",
    description2:"Add a new risk by selecting 'Add Risk' below. You can maintain a risk by selecting it in the table below. If the probability of a risk is so to speak 100%, you should convert it to an issue in the issue register (under Change)"
  },
  riskManagementApproach: {
    title: "Risk Management Approach",
    description: "The risk management approach describes how risk will be managed and what level of risk is acceptable. What will we do to make sure the level of uncertainty is managed?",
    fields: {
      process: {
        title: "Process and Procedures",
        help: `Will the project have any rules, routines or processes in place ensuring risks are identified, assessed and mitigated?
          Are there any standard procedures to be followed? Any planned deviation from these procedures? If so, why?
          How will we make sure the risk management procedure is followed?
          Will the risk management process explicitly address information security risks related to classified information or data privacy? `,
        description: "Describe how risks will be: Identified, Assessed, Planned, Implemented"
      },
      tools: {
        title: "Tools and Techniques",
        help: `Any identification techniques to be used (review lessons, checklists, brainstorming, workshops, breakdown structures) ?
          Any estimation techniques to be used (probability trees, expected value, risk models)?
          Which tools will be used to manage risk?`,
        description: "Describe tools and techniques to be used in risk management"
      },
      reporting: {
        title: "Reporting",
        help: `When will risk be reported? Where will risk be reported and who will receive the risk reports?`,
        description: "The reports to be produced, their purpose, timing and recipients"
      },
      timing: {
        title: "Timing of activities",
        help: `When will risk management activities occur?
          Any specific activities in Initiation or beginning/end of stages?`,
        description: "Describe the timing of risk management activities"
      },
      roles: {
        title: "Roles and responsibilities",
        help: `Who makes sure risks are captured? Assessed? Planned? Implemented? Who approves a
          response? Any policy on who owns which types of risks? Who communicates what?
          Who calls and organizes risk management activities and reviews?`,
        description: "Define the roles and responsibilities for the activities"
      },
      tolerance: {
        title: "Risk Tolerance",
        help: `What is attitude towards taking risk - is the risk appetite high or is it low?
          What uncertainty level is OK? Are there areas where high uncertainty is accepted and others uncertainty needs to be low?
          When should a risk be escalated?`,
        description: "Define the risk appetite and when a risk should be escalated"
      },
      budget: {
        title: "Risk Budget",
        help: `Do we expect to set aside time, resources or money to deal with risks?
If not, where will the resources to deal with risk come from?`,
        description: "Describe the risk budget, if any, and how it will be used"
      }
    }
  }
};



// WEBPACK FOOTER //
// ./views/risk/labels/english.js